module.exports = __webpack_public_path__ + "static/media/main-picker.441e4fc5.svg";